/** Alert severity values. Should match the backend enum values. */
export default {
  critical: 1,
  warning: 2,
  notice: 3,
};
